module.exports = __webpack_public_path__ + "img/frances-ellen-watkins-harper.e23795b5.png";